import brain_en from "./en/brain.json";
import chat_en from "./en/chat.json";
import common_en from "./en/common.json";
import config_en from "./en/config.json";
import contact_en from "./en/contact.json";
import delete_brain_en from "./en/deleteOrUnsubscribeFromBrain.json";
import explore_en from "./en/explore.json";
import external_api_definition_en from "./en/external_api_definition.json";
import home_en from "./en/home.json";
import invitation_en from "./en/invitation.json";
import knowlegde_en from "./en/knowledge.json";
import login_en from "./en/login.json";
import logout_en from "./en/logout.json";
import monetization_en from "./en/monetization.json";
import translation_en from "./en/translation.json";
import upload_en from "./en/upload.json";
import user_en from "./en/user.json";

import brain_de from "./de/brain.json";
import chat_de from "./de/chat.json";
import common_de from "./de/common.json";
import config_de from "./de/config.json";
import contact_de from "./de/contact.json";
import delete_brain_de from "./de/deleteOrUnsubscribeFromBrain.json";
import explore_de from "./de/explore.json";
import external_api_definition_de from "./de/external_api_definition.json";
import home_de from "./de/home.json";
import invitation_de from "./de/invitation.json";
import knowlegde_de from "./de/knowledge.json";
import login_de from "./de/login.json";
import logout_de from "./de/logout.json";
import monetization_de from "./de/monetization.json";
import translation_de from "./de/translation.json";
import upload_de from "./de/upload.json";
import user_de from "./de/user.json";

import brain_fr from "./fr/brain.json";
import chat_fr from "./fr/chat.json";
import common_fr from "./fr/common.json";
import config_fr from "./fr/config.json";
import contact_fr from "./fr/contact.json";
import delete_brain_fr from "./fr/deleteOrUnsubscribeFromBrain.json";
import explore_fr from "./fr/explore.json";
import external_api_definition_fr from "./fr/external_api_definition.json";
import home_fr from "./fr/home.json";
import invitation_fr from "./fr/invitation.json";
import knowlegde_fr from "./fr/knowledge.json";
import login_fr from "./fr/login.json";
import logout_fr from "./fr/logout.json";
import monetization_fr from "./fr/monetization.json";
import translation_fr from "./fr/translation.json";
import upload_fr from "./fr/upload.json";
import user_fr from "./fr/user.json";

import brain_it from "./it/brain.json";
import chat_it from "./it/chat.json";
import common_it from "./it/common.json";
import config_it from "./it/config.json";
import contact_it from "./it/contact.json";
import delete_brain_it from "./it/deleteOrUnsubscribeFromBrain.json";
import explore_it from "./it/explore.json";
import external_api_definition_it from "./it/external_api_definition.json";
import home_it from "./it/home.json";
import invitation_it from "./it/invitation.json";
import knowlegde_it from "./it/knowledge.json";
import login_it from "./it/login.json";
import logout_it from "./it/logout.json";
import monetization_it from "./it/monetization.json";
import translation_it from "./it/translation.json";
import upload_it from "./it/upload.json";
import user_it from "./it/user.json";

export type Translations = {
  brain: typeof import("./en/brain.json");
  chat: typeof import("./en/chat.json");
  common: typeof import("./en/common.json");
  config: typeof import("./en/config.json");
  contact: typeof import("./en/contact.json");
  delete_or_unsubscribe_from_brain: typeof import("./en/deleteOrUnsubscribeFromBrain.json");
  explore: typeof import("./en/explore.json");
  home: typeof import("./en/home.json");
  invitation: typeof import("./en/invitation.json");
  login: typeof import("./en/login.json");
  logout: typeof import("./en/logout.json");
  monetization: typeof import("./en/monetization.json");
  translation: typeof import("./en/translation.json");
  upload: typeof import("./en/upload.json");
  user: typeof import("./en/user.json");
  knowledge: typeof import("./en/knowledge.json");
  external_api_definition: typeof import("./en/external_api_definition.json");
};

export enum SupportedLanguages {
  en = "en",
  fr = "fr",
  it = "it",
  de = "de",
}

export const defaultNS = "translation";

export const resources: Record<SupportedLanguages, Translations> = {
  en: {
    brain: brain_en,
    chat: chat_en,
    common: common_en,
    config: config_en,
    contact: contact_en,
    explore: explore_en,
    home: home_en,
    invitation: invitation_en,
    login: login_en,
    logout: logout_en,
    monetization: monetization_en,
    translation: translation_en,
    upload: upload_en,
    user: user_en,
    delete_or_unsubscribe_from_brain: delete_brain_en,
    knowledge: knowlegde_en,
    external_api_definition: external_api_definition_en,
  },
  fr: {
    brain: brain_fr,
    chat: chat_fr,
    common: common_fr,
    config: config_fr,
    contact: contact_fr,
    explore: explore_fr,
    home: home_fr,
    invitation: invitation_fr,
    login: login_fr,
    logout: logout_fr,
    monetization: monetization_fr,
    translation: translation_fr,
    upload: upload_fr,
    user: user_fr,
    delete_or_unsubscribe_from_brain: delete_brain_fr,
    knowledge: knowlegde_fr,
    external_api_definition: external_api_definition_fr,
  },
  it: {
    brain: brain_it,
    chat: chat_it,
    common: common_it,
    config: config_it,
    contact: contact_it,
    explore: explore_it,
    home: home_it,
    invitation: invitation_it,
    login: login_it,
    logout: logout_it,
    monetization: monetization_it,
    translation: translation_it,
    upload: upload_it,
    user: user_it,
    delete_or_unsubscribe_from_brain: delete_brain_it,
    knowledge: knowlegde_it,
    external_api_definition: external_api_definition_it,
  },
  de: {
    brain: brain_de,
    chat: chat_de,
    common: common_de,
    config: config_de,
    contact: contact_de,
    explore: explore_de,
    home: home_de,
    invitation: invitation_de,
    login: login_de,
    logout: logout_de,
    monetization: monetization_de,
    translation: translation_de,
    upload: upload_de,
    user: user_de,
    delete_or_unsubscribe_from_brain: delete_brain_de,
    knowledge: knowlegde_de,
    external_api_definition: external_api_definition_de,
  },
} as const;
